import { Component, Input } from '@angular/core';

import { ImageComponent } from '@atoms/image/image.component';

@Component({
  selector: 'app-branch-promo',
  imports: [ImageComponent],
  templateUrl: './branch-promo.component.html',
  styleUrl: './branch-promo.component.scss',
})
export class BranchPromoComponent {
  @Input('justify-content') justifyContent: 'space-between' | 'flex-end' = 'flex-end';
  @Input('custom-background') customBackground?: boolean;
  @Input() gradient?: 'dark';
}
